/**
 * @file   建筑详情
 * @create macaiqi 2021/11/25
 * @update
 */
import React from 'react';
import './index.scss';
import { htmltoStr } from '@/utils';
import { Link } from 'react-router-dom';

// 首页
const InnerTitle = ({name, id}) => {
  return (
    <div className="inner-title">
      {/* <span className="block"/> */}
      <div className="name">{htmltoStr(name)}</div>
      {/* <div className="line" /> */}
      {id && <Link to={`/Relation/${id}`} className="more">查看更多&gt;&gt;</Link>}
    </div>)
};

export default InnerTitle;
